import React from 'react';

export const Instruction2 = () => {
  return (
    <div className="package-instruction__content">
      <p>
        Welcome to the&nbsp;<strong>UCAT</strong>&nbsp;exam.
      </p>
      <p>
        Please verify your name and examination title. If either is incorrect, raise your hand for the invigilator (if
        you are in a test centre) or make contact with the proctor (if testing online).
      </p>
      <p>
        If you choose to proceed you acknowledge that you will be monitored at all times and both audio and video may be
        recorded. If you have questions about this policy, raise your hand for the invigilator (if you are in a test
        centre) or make contact with the proctor (if testing online).
      </p>
      <p>Non-disclosure agreement and general terms of use for exams developed for the UCAT Consortium:</p>

      <ul>
        <li>
          The exam is made available to you as an examinee solely for the purpose of being assessed in this exam. You
          are expressly prohibited from disclosing, publishing, reproducing or transmitting this exam, in whole or in
          part, in any form or by any means including visual, aural, verbal, written, electronic or mechanical means,
          for any purpose, without the prior express written permission of the UCAT Consortium.
        </li>
        <li>Your personal data and test data will be stored in Pearson VUE and UCAT databases.</li>
        <li>All examination contents are the published, confidential and propriety materials of UCAT.</li>
      </ul>

      <p>
        Click the&nbsp;<strong>Next (N)</strong>&nbsp;button when you are ready to begin the exam.
      </p>
    </div>
  );
};
